export function appendAt(list: any[], index: number, value: any) {
  if (index < list.length) {
    list.splice(index, 0, value);
  } else {
    list.push(value);
  }
}